import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { api, Status } from "@api";
import { clearToken, clearUser } from "@redux/auth/authSlice";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    padding-top: 15px;
    margin: 0;
  }
  .ant-modal-title {
    text-align: center;
    color: #e9a94d;
    /* color:${(props) => props.theme.golden} !important; */
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 26px;
  }
`;

const ModalFooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
  background: ${(props) => props.theme.golden};
  :hover {
    background: ${(props) => props.theme.goldenVertical} !important;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  border-radius: 0 0 8px 8px;
  cursor: pointer;
`;

const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

const SessionExpiredDialog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionStatus = useSelector((state) => state.auth.sessionStatus);

  const resetSessionState = () => {
    // clear token and user from redux
    dispatch(clearToken());
    dispatch(clearUser());

    // clear token and user from localstorage
    localStorage.clearToken();
    localStorage.clearUser();

    // update token to request obj
    api.setSessionToken("");

    navigate(`/${PUBLIC_ROUTE.LOGIN}`);
  };

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      width={310}
      open={sessionStatus === Status.ERROR}
      onOk={resetSessionState}
      okText={t("common.ok")}
      footer={null}
    >
      <div style={{ textAlign: "center" }}>
        <ModalTitle>{t("error.sessionExpiredTitle")}</ModalTitle>
        <ModalText>{t("error.sessionExpiredSubtitle")}</ModalText>
      </div>
      <ModalFooterContainer onClick={resetSessionState}>
        {t("common.ok")}
      </ModalFooterContainer>
    </Modal>
  );
};

export default SessionExpiredDialog;
